module.exports = __webpack_public_path__ + "static/media/icon.bbef65e7.png";